// Environment configuration
export const ENV = {
  // API Configuration
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001/api',
  API_TIMEOUT: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10),

  // App Configuration
  APP_NAME: process.env.REACT_APP_APP_NAME || 'Kiosk Gaming Admin',
  APP_VERSION: process.env.REACT_APP_APP_VERSION || '1.0.0',

  // Environment
  NODE_ENV: process.env.REACT_APP_NODE_ENV || 'development',
  IS_DEVELOPMENT: process.env.NODE_ENV === 'development',
  IS_PRODUCTION: process.env.NODE_ENV === 'production',

  // Optional: Cloudflare Turnstile (CAPTCHA) for admin login when TURNSTILE_ENABLED on backend
  TURNSTILE_ENABLED: process.env.REACT_APP_TURNSTILE_ENABLED === 'true',
  TURNSTILE_SITE_KEY: process.env.REACT_APP_TURNSTILE_SITE_KEY || '',

  /** Canonical platform USD tier owner_id (optional; defaults to backend migration UUID). */
  PLATFORM_USD_OWNER_ID: process.env.REACT_APP_PLATFORM_USD_OWNER_ID || '',
} as const;

// Validate required environment variables
export const validateEnv = () => {
  const requiredVars = [
    'REACT_APP_API_BASE_URL',
  ];

  const missingVars = requiredVars.filter(varName => !process.env[varName]);

  if (missingVars.length > 0) {
    console.warn('Missing environment variables:', missingVars);
    console.warn('Using default values. Please create a .env file with the required variables.');
  }
};

// Call validation on import
validateEnv();
